// Saying why a request was refused (2026-10-12).
//
// `problemView` turns a described failure (`describeError` in @clavian/api-client, or a refusal the station relayed to
// the kiosk) into the words a person reads: the copy for its problem code, specific and actionable, with the server's
// own `detail` where that is the better sentence (a limit in rupees). Only a code with no copy, or a 5xx, gets a
// generic line, and that comes with "Try again" and the reference to quote to support. Pure: no React, no i18next.
/** Codes whose server `detail` names the amounts or items concerned, and is the better sentence when present. */
export const DETAIL_LED_CODES = new Set([
    'wallet_limit',
    'wallet_adjustment_over_limit',
    'credit_limit_exceeded',
    'currency_mismatch',
    'stock_count_incomplete',
    'unprocessable',
]);
const RETRYABLE_CODES = new Set(['rate_limited', 'station_timeout', 'otp_delivery_unavailable', 'catalogue_provider_unavailable', 'art_source_unavailable']);
/** The key of the line to try for a code, most specific first. */
function candidateKeys(facts, code) {
    const keys = [];
    if (facts.total !== undefined)
        keys.push(`${code}_withTotal`);
    if (facts.activeSession !== undefined)
        keys.push(`${code}_withStation`);
    keys.push(code);
    return keys;
}
function toCamel(code) {
    return code.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}
export function problemView(facts, copy, options = {}) {
    const reference = facts.requestId;
    const fields = facts.fields.map((entry) => ({ field: entry.field, message: entry.message }));
    const generic = (key, retryable) => ({
        message: options.fallback ?? copy.line(key) ?? '',
        code: facts.code,
        specific: false,
        retryable,
        reference,
        fields,
        isValidation: false,
    });
    if (facts.kind === 'transport' && facts.status === undefined)
        return { ...generic('network', true), message: copy.line('network') ?? '', reference: undefined };
    if (facts.status !== undefined && facts.status >= 500)
        return generic('serverError', true);
    const code = facts.code;
    if (code !== undefined) {
        const values = {};
        if (facts.total !== undefined && copy.money !== undefined)
            values.total = copy.money(facts.total);
        if (facts.activeSession !== undefined) {
            values.station = facts.activeSession.station;
            values.venue = facts.activeSession.venue;
        }
        const keys = code === 'station_timeout' ? [toCamel(code)] : candidateKeys(facts, code);
        let line;
        for (const key of keys) {
            if (key.endsWith('_withTotal') && values.total === undefined)
                continue;
            line = copy.line(key, values);
            if (line !== undefined)
                break;
        }
        const detail = DETAIL_LED_CODES.has(code) && facts.kind === 'problem' && facts.detail !== undefined && facts.detail !== '' ? facts.detail : undefined;
        if (line !== undefined || detail !== undefined) {
            return {
                message: detail ?? line ?? '',
                code,
                specific: true,
                retryable: RETRYABLE_CODES.has(code),
                reference: undefined,
                fields,
                isValidation: code === 'validation_failed',
            };
        }
    }
    return generic('generic', true);
}
//# sourceMappingURL=problems.js.map